import { render, staticRenderFns } from "./CbsCommentGeneral.vue?vue&type=template&id=7eeb5062&scoped=true&"
import script from "./CbsCommentGeneral.vue?vue&type=script&lang=js&"
export * from "./CbsCommentGeneral.vue?vue&type=script&lang=js&"
import style0 from "./CbsCommentGeneral.vue?vue&type=style&index=0&id=7eeb5062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eeb5062",
  null
  
)

/* custom blocks */
import block0 from "@/locales/components/CommentTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fcomponents%2Fcbs-comment-general%2FCbsCommentGeneral.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports